import React, { useEffect } from 'react'

const useHandleclickOutside = (ref, callback) => {

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && event && !ref.current.contains(event.target)) {
        callback()
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref,callback])
}

export default useHandleclickOutside
